// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__DT7bJ {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.styles_gridWrapper__\\+47LX {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
}
@media (max-width: 768px) {
  .styles_gridWrapper__\\+47LX {
    grid-template-columns: 1fr;
  }
}

.styles_inputWrapper__a-O8N {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
@media (max-width: 1920px) {
  .styles_inputWrapper__a-O8N {
    display: grid;
    grid-template-columns: 1fr 4fr;
  }
}
@media (max-width: 768px) {
  .styles_inputWrapper__a-O8N {
    grid-template-columns: 1fr;
  }
}

.styles_input__OLf\\+r {
  width: 100%;
}

.styles_totalWrapper__amRVs {
  width: 100%;
  max-width: 334px;
}
@media (max-width: 992px) {
  .styles_totalWrapper__amRVs {
    align-self: center;
  }
}
@media (max-width: 576px) {
  .styles_totalWrapper__amRVs {
    max-width: 100%;
  }
}

.styles_decimalsWrapper__tIQJk {
  display: flex;
}

.styles_btnWrapper__qIU4e {
  width: 100%;
  max-width: 334px;
  height: 57px;
}
@media (max-width: 992px) {
  .styles_btnWrapper__qIU4e {
    align-self: center;
  }
}
@media (max-width: 576px) {
  .styles_btnWrapper__qIU4e {
    max-width: 100%;
  }
}

.styles_checkoutBlock__Kpwyb {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_modalWrapper__U0nTA {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_subheading__eN86k {
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 1200px) {
  .styles_subheading__eN86k {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_valueGrid__wTuvI {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
}
@media (max-width: 576px) {
  .styles_valueGrid__wTuvI {
    grid-template-columns: 1fr;
  }
}

.styles_valueWrapper__vW-T8,
.styles_valueContractWrapper__D8345 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

@media (max-width: 1200px) {
  .styles_valueContractWrapper__D8345 {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.styles_valueHeading__XmIdk {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 1200px) {
  .styles_valueHeading__XmIdk {
    font-size: 12px;
    line-height: 15px;
  }
}

.styles_value__CX2CE,
.styles_valueContract__OkFzz {
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: #ffffff;
}
@media (max-width: 1200px) {
  .styles_value__CX2CE,
.styles_valueContract__OkFzz {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_valueContract__OkFzz {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
@media (max-width: 1200px) {
  .styles_valueContract__OkFzz {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/reflectionContent/standartContent/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AAFF;ACqBE;EDtBF;IAMI,0BAAA;EADF;AACF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AADF;ACpBE;EDkBF;IAMI,aAAA;IACA,8BAAA;EAAF;AACF;ACIE;EDZF;IAWI,0BAAA;EACF;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;AChBE;EDaF;IAKI,kBAAA;EAEF;AACF;ACTE;EDCF;IASI,eAAA;EAGF;AACF;;AAAA;EACE,aAAA;AAGF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAFF;ACpCE;EDmCF;IAMI,kBAAA;EADF;AACF;AC7BE;EDuBF;IAUI,eAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BEpFS;AFoFX;ACzEE;EDmEF;IASI,eAAA;IACA,iBAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AACF;ACnEE;ED+DF;IAMI,0BAAA;EAEF;AACF;;AACA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAEF;;AClGE;EDmGF;IAEI,sBAAA;IACA,uBAAA;IACA,QAAA;EAEF;AACF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BE7HS;AF+HX;AClHE;ED2GF;IAQI,eAAA;IACA,iBAAA;EAGF;AACF;;AAAA;;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cEjJM;AFoJR;ACjIE;EDwHF;;IASI,eAAA;IACA,iBAAA;EAKF;AACF;;AAFA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAKF;AC9IE;EDsIF;IAMI,WAAA;EAMF;AACF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n}\n\n.gridWrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 24px;\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n\n.inputWrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n\n  @include xxxxl {\n    display: grid;\n    grid-template-columns: 1fr 4fr;\n  }\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n\n.input {\n  width: 100%;\n}\n\n.totalWrapper {\n  width: 100%;\n  max-width: 334px;\n\n  @include lg {\n    align-self: center;\n  }\n\n  @include sm {\n    max-width: 100%;\n  }\n}\n\n.decimalsWrapper {\n  display: flex;\n  //grid-template-columns: repeat(2, 1fr);\n  //\n  //@include md {\n  //  grid-template-columns: 1fr;\n  //}\n}\n\n.btnWrapper {\n  width: 100%;\n  max-width: 334px;\n  height: 57px;\n\n  @include lg {\n    align-self: center;\n  }\n\n  @include sm {\n    max-width: 100%;\n  }\n}\n\n.checkoutBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.modalWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.subheading {\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-80;\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.valueGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 16px;\n\n  @include sm {\n    grid-template-columns: 1fr;\n  }\n}\n\n.valueWrapper,\n.valueContractWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.valueContractWrapper {\n  @include xl {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n.valueHeading {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-50;\n\n  @include xl {\n    font-size: 12px;\n    line-height: 15px;\n  }\n}\n\n.value,\n.valueContract {\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: $white;\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.valueContract {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  @include xl {\n    width: 100%;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__DT7bJ`,
	"gridWrapper": `styles_gridWrapper__+47LX`,
	"inputWrapper": `styles_inputWrapper__a-O8N`,
	"input": `styles_input__OLf+r`,
	"totalWrapper": `styles_totalWrapper__amRVs`,
	"decimalsWrapper": `styles_decimalsWrapper__tIQJk`,
	"btnWrapper": `styles_btnWrapper__qIU4e`,
	"checkoutBlock": `styles_checkoutBlock__Kpwyb`,
	"modalWrapper": `styles_modalWrapper__U0nTA`,
	"subheading": `styles_subheading__eN86k`,
	"valueGrid": `styles_valueGrid__wTuvI`,
	"valueWrapper": `styles_valueWrapper__vW-T8`,
	"valueContractWrapper": `styles_valueContractWrapper__D8345`,
	"valueHeading": `styles_valueHeading__XmIdk`,
	"value": `styles_value__CX2CE`,
	"valueContract": `styles_valueContract__OkFzz`
};
export default ___CSS_LOADER_EXPORT___;
